import React, { ReactElement } from 'react'
import { isObject } from 'lodash'

export type GenericCellProps = {
  data: string | number | { style: object; value: string | number }
}

export default function GenericCell({ data }: GenericCellProps): ReactElement {
  if (isObject(data)) {
    const { style, value } = data

    return <div style={style}>{value}</div>
  }

  return <div>{data}</div>
}
